import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const spreadsheet_id = '1-FXQ2A4IQ4xKlfU7H4LYw488Ty_4ATJjt7Fgq9ehTBQ';
const tab_name = 'Manually%20Entered%20Movie%20Quotes';
const googlesheetUrl = `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheet_id}/values/${tab_name}?alt=json&key=${process.env.VUE_APP_GOOGLE_SHEET_API_KEY}`;

const movieApi_BASE_URL = `https://www.omdbapi.com/?apikey=${process.env.VUE_APP_OMDB_API_KEY}&page=1&type=movie&r=json`;

export default new Vuex.Store({



    state: {

        loading: false,

        quotes: [],
        imdbSet: [],
        titleSet: [],
        yearSet: [],
        quoteSet: [],
        actorSet: [],
        difficultySet: [],
        alldata: null,

        selectedMovieData: {}, // The full movie data: Title, Reviews, Plot, etc.
    },



    mutations: {

        STATE_SET_loading(state, payload) {
            state.loading = payload
        },

        STATE_SET_quotes(state, payload) {
            state.quotes = payload
        },
        STATE_SET_imdbSet(state, payload) {
            state.imdbSet = payload
        },
        STATE_SET_titleSet(state, payload) {
            state.titleSet = payload
        },
        STATE_SET_yearSet(state, payload) {
            state.yearSet = payload
        },
        STATE_SET_quoteSet(state, payload) {
            state.quoteSet = payload
        },
        STATE_SET_actorSet(state, payload) {
            state.actorSet = payload
        },
        STATE_SET_difficultySet(state, payload) {
            state.difficultySet = payload
        },
        STATE_SET_alldata(state, payload) {
            state.alldata = payload
        },

        STATE_SET_selectedMovieData(state, payload) {
            state.selectedMovieData = payload
        },
    },



    actions: {

        /**
         * FETCH, SET, & PARSE GOOGLE SHEET DATA
         *
         * @param dispatch
         * @param commit
         * @constructor
         */
        async FETCH_GOOGLESHEET({dispatch, commit}) {
            commit('STATE_SET_loading', true);
            await axios
                .get(googlesheetUrl)
                .then(response => {
                    // console.log('RESPONSE.data.values: ', response.data.values);
                    let entries = response.data.values;
                    entries.shift(); // This removes the first row of data which are the Titles: "IMDB", "TITLE", "YEAR", etc...
                    commit('STATE_SET_alldata', entries);
                    dispatch('PARSE_DATA', entries);
                })
                .catch(error => {
                    console.log('FETCH_GOOGLESHEET: ', error);
                    commit('STATE_SET_loading', false);
                });
        },


        /**
         * REFERENCE: https://github.com/albertauyeung/quotes-app/blob/master/index.html
         *
         * @param commit
         * @param entries
         * @constructor
         */
        async PARSE_DATA({commit}, entries) {
            let quotes = [];
            let imdbSet = [];
            let titleSet = [];
            let yearSet = [];
            let quoteSet = [];
            let actorSet = [];
            let difficultySet = [];

            await entries.forEach( (value) => {
                let entry = {
                    imdb: value[0] ? value[0] : '(No IMDB)',
                    title: value[1] ? value[1] : '(No TITLE)',
                    year: value[2] ? value[2] : '(No YEAR)',
                    quote: value[3] ? value[3] : '(No QUOTE)',
                    actor: value[4] ? value[4] : '(No ACTOR)',
                    difficulty: value[5] ? value[5] : 'Medium', // Set a default to 'medium'. Otherwise use '(None)'
                };

                imdbSet.push(entry.imdb);
                titleSet.push(entry.title);
                yearSet.push(entry.year);
                quoteSet.push(entry.quote);
                actorSet.push(entry.actor);
                difficultySet.push(entry.difficulty);
                quotes.push(entry);
            });

            //console.log('PARSE_DATA: quotes = ', quotes);

            commit('STATE_SET_quotes', quotes);
            commit('STATE_SET_imdbSet', imdbSet);
            commit('STATE_SET_titleSet', titleSet);
            commit('STATE_SET_yearSet', yearSet);
            commit('STATE_SET_quoteSet', quoteSet);
            commit('STATE_SET_actorSet', actorSet);
            commit('STATE_SET_difficultySet', difficultySet);
            commit('STATE_SET_loading', false);
        },


        /**
         * FETCH OMDB MOVIE DATA
         */
        async FETCH_MOVIE_DATA({commit}, id) {
            const fetchUrl = `${movieApi_BASE_URL}&i=${id}`;
            // console.log('FETCH URL = ', fetchUrl);

            await axios
                .get(fetchUrl)
                .then(response => {
                    // console.log('response data = ', response.data);
                    commit('STATE_SET_selectedMovieData', response.data);
                })
                .catch(error => {
                    console.log('FETCH_MOVIE_DATA: ', error);
                });
        }
    },



    getters: {

        loading(state) {
            return state.loading
        },

        quotes(state) {
            return state.quotes
        },
        imdbSet(state) {
            return state.imdbSet
        },
        titleSet(state) {
            return state.titleSet
        },
        yearSet(state) {
            return state.yearSet
        },
        quoteSet(state) {
            return state.quoteSet
        },
        actorSet(state) {
            return state.actorSet
        },
        difficultySet(state) {
            return state.difficultySet
        },
        alldata(state) {
            return state.alldata
        },

        selectedMovieData(state) {
            return state.selectedMovieData
        },
    },



    modules: {
    }
})
